module.exports = __webpack_public_path__ + "3c96f718967249e267ccb21f44c42340.svg";